import { useEffect, useRef } from 'react';

import {
  EnrichVacancyModalContextProps,
  EnrichVacancyModalType,
} from '../components/EnrichVacancyModalContext/EnrichVacancyModalContext.types';

import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';
import { useGlobalDialogData } from 'stores/global-dialogs/hooks/useGlobalDialogData';
import { useIsGlobalDialogOpen } from 'stores/global-dialogs/hooks/useIsGlobalDialogOpen';
import { EnrichTab } from '../components/EditEnrichedVacancyForm/EditEnrichedVacancy.types';
import { EnrichVacancyModalState } from '../components/EnrichVacancyModalContext/EnrichVacancyModalContext.types';

export const useSetupModalWhenVisible = ({
  setVacancy,
  setState,
  setModalType,
  setEditVacancyTab,
}: Pick<EnrichVacancyModalContextProps, 'setVacancy' | 'setState' | 'setEditVacancyTab' | 'setEditVacancyTab'> & {
  setModalType: (modalType: EnrichVacancyModalType) => void;
}) => {
  const isVisible = useIsGlobalDialogOpen(GlobalDialogType.EnrichVacancy);
  const dialogData = useGlobalDialogData({ dialogType: GlobalDialogType.EnrichVacancy, isVisible });
  const didRunSetupWhenVisibleRef = useRef(false);

  useEffect(() => {
    if (!isVisible) {
      didRunSetupWhenVisibleRef.current = false;
      setVacancy(null);
    }
  }, [isVisible, setVacancy]);

  useEffect(() => {
    if (didRunSetupWhenVisibleRef.current) return;

    if (isVisible && dialogData) {
      didRunSetupWhenVisibleRef.current = true;

      setEditVacancyTab(
        (dialogData && 'initialEditVacancyTab' in dialogData && dialogData.initialEditVacancyTab) ||
          EnrichTab.EnrichedVersion,
      );

      if ('vacancy' in dialogData && dialogData.vacancy) {
        setVacancy(dialogData.vacancy);
        setModalType(dialogData.vacancy.type === 'INDEED' ? EnrichVacancyModalType.Indeed : EnrichVacancyModalType.Ats);

        if (dialogData.vacancy.is_improved) {
          setState(EnrichVacancyModalState.EditingEnrichedVacancy);

          return;
        }

        setState(EnrichVacancyModalState.WaitingToEnrichVacancy);

        return;
      }

      if ('modalType' in dialogData && dialogData.modalType) {
        setModalType(dialogData.modalType);
        setState(EnrichVacancyModalState.ChoosingCreationMethod);

        return;
      }

      throw new Error('Invalid dialog data');
    }
  }, [isVisible, dialogData]);
};
